import { ReactComponent as IntroductionIcon } from "../icon/pheno/introduction.svg";
import { ReactComponent as PlantIcon } from "../icon/pheno/Plant.svg";
import { ReactComponent as AnimalIcon } from "../icon/pheno/Animals.svg";
import { ReactComponent as PhenoIcon2 } from "../icon/表型管理2.svg";
import { ReactComponent as PhenotypicIcon } from "../icon/pheno/Phenotypic.svg";

const PhenoMenuList = [
  {
    key: "left1",
    label: (
      <a
        href="#/Breeding/introduction/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <IntroductionIcon width={20} style={{margin:"0 5px"}} />
        {/* Plant phenotypic management */}
        Introduction
      </a>
    ),
  },
  {
    key: "left2",
    label: (
      <a
        href="#/Breeding/plant/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <PlantIcon width={20} style={{margin:"0 5px"}} />
        {/* Plant phenotypic management */}
        Plant phenotypic
      </a>
    ),
  },
  {
    key: "left3",
    label: (
      <a
        href="#/Breeding/animal/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <AnimalIcon width={20}  style={{margin: "0 5px"}}/>
        {/* Animal phenotypic management */}
        Animal phenotypic
      </a>
    ),
  },
  {
    key: "left4",
    label: (
      <a
        href="#/Breeding/datamanagement/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <PhenoIcon2 width={20} style={{margin:"0 5px"}} />
        {/* Plant phenotypic management */}
        Data Management
      </a>
    ),
  },
  {
    key: "left5",
    label: (
      <a
        href="#/Breeding/phenotypic/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <PhenotypicIcon width={20} style={{margin:"0 5px"}} />
        PE Integration
      </a>
    ),
  },
];
export default PhenoMenuList;
